import React from 'react';
import { AuditLog } from '@myapp/contract';
import { auditLogActionLabels } from '../../../entities/audit-log';

interface AuditLogItemProps {
  entry: AuditLog;
}

function formatDate(iso: string): string {
  const d = new Date(iso);
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');
  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export const AuditLogItem: React.FC<AuditLogItemProps> = ({ entry }) => {
  const label = auditLogActionLabels[entry.action as keyof typeof auditLogActionLabels] ?? entry.action;
  const actorName = entry.actor?.name ?? 'System';

  return (
    <div className="flex gap-3 py-3 border-b border-gray-100 last:border-b-0">
      
      <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#004494] flex items-center justify-center text-white text-xs font-medium">
        {actorName === 'System' ? 'SYS' : actorName.slice(0, 2).toUpperCase()}
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-800">{label}</span>
          <span className="text-xs text-gray-400">{formatDate(entry.createdAt)}</span>
        </div>
        <span className="text-xs text-gray-500">{actorName}</span>
        {entry.description && (
          <p className="text-sm text-gray-600 mt-0.5 break-words">{entry.description}</p>
        )}
      </div>
    </div>
  );
};
